import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ShapeProjectGalleryIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/shape-project-gallery"><path id="Icon" d="M6 20.25H5.75C4.64543 20.25 3.75 19.3546 3.75 18.25V6C3.75 5.30964 4.30964 4.75 5 4.75H9C9.55228 4.75 10 5.19772 10 5.75V6.25C10 6.52614 10.2239 6.75 10.5 6.75H17.75C18.3023 6.75 18.75 7.19772 18.75 7.75V9M19.0147 19.6584L22.2124 12.5105C22.5824 11.6835 21.9773 10.75 21.0714 10.75H8.64814C8.25384 10.75 7.89634 10.9817 7.73532 11.3416L4.53757 18.4895C4.16764 19.3165 4.77271 20.25 5.6786 20.25H18.1019C18.4962 20.25 18.8537 20.0183 19.0147 19.6584Z" stroke="currentColor" strokeWidth={1.5} /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ShapeProjectGalleryIcon;